export default "__VITE_ASSET__6e2102c8__"